import { TweenMax, Back, Elastic } from "gsap";

let animate = {
  in: (element: any, delay: number) => {
    TweenMax.from(element, 0.5, { opacity: 0, delay: delay / 5 });
    TweenMax.from(element, 0.5, {
      y: "+=60",
      ease: Back.easeOut,
      delay: delay / 5,
    });
  },
  pulse: (element: any) => {
    TweenMax.set(element, { x: "-15px", force3D: true });
    TweenMax.to(element, 0.75, {
      x: "0",
      force3D: true,
      ease: Elastic.easeOut,
      onUpdate: () => {
        //fixes bug on ios where placeholder bounces up//
        TweenMax.set(element, { left: 0 });
      },
    });
  },
  red: (element: any) => {
    TweenMax.to(element, 0.75, {
      borderColor: "red",
      ease: Elastic.easeOut,
    });
  },
};

export { animate };
